<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>

<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5 login-bg"></b-col>

      <!-- Reset Password-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-text class="mb-2">
            <img class="full-width" height="auto" src="~@/assets/images/logo/logo.svg" alt="logo">
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- code -->
              <b-form-group
                label="Reset Password Code"
                label-for="reset-password-code"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Code"
                  :rules="{ required: true }"
                >
                  <b-form-input
                    id="reset" cy="reset-code"
                    v-model="form.code" autocomplete="new-password"
                    :state="errors.length > 0 ? false:null"
                    name="reset"
                    placeholder="Enter code"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label>New Password</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password" cy="reset-password"
                      v-model="form.password" autocomplete="new-password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="showPassword ? 'text' : 'password'"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="showPassword ? 'EyeIcon' : 'EyeOffIcon'"
                        @click="showPassword = !showPassword"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="passwordConfirm">Confirm Password</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password Confirm"
                  :rules="{ required: true, min: 5, match: form.password }"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="passwordConfirm" cy="reset-password-confirm"
                      v-model="form.passwordConfirm" autocomplete="new-password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="showPasswordConfirm ? 'text' : 'password'"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="showPasswordConfirm ? 'EyeIcon' : 'EyeOffIcon'"
                        @click="showPasswordConfirm = !showPasswordConfirm"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                @click="validationForm"
              >
                Submit
              </b-button>

              <b-button
                variant="outline-primary"
                block
                @click="goBack()"
              >
                Back
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import VisitorUsersService from '@/services/OffsiteUsersService';

export default {
  components: {},
  mixins: [togglePasswordVisibility],
  data() {
    return {
      email: '',
      showPassword: false,
      showPasswordConfirm: false,
      form: {
        password: '',
        passwordConfirm: '',
        code: '',
      },
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      bgImage: require('@/assets/images/pages/login-bg.jpg'),
      required,
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  mounted() {
    const { email } = this.$route.params;

    if (email) {
      this.email = email;
    } else {
      this.goBack();
    }
  },
  methods: {
    validationForm() {
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          this.resetPassword();
        }
      })
    },
    resetPassword() {
      VisitorUsersService.resetPassword(this.email, this.form.code, this.form.password).then(() => {
        this.$toast.success('Password Reset Successful', {
          toastClassName: ['toast-std', 'success-toast'],
        });

        this.$router.push({ name: 'login' });
      }).catch(() => {
        this.$toast.error('Something went wrong, please check your details and try again', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
      })
    },
    goBack() {
      this.$router.push({ name: 'forgot-password' });
    },
  },
}
</script>
